import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Box, Grid, InputAdornment } from '@mui/material'
import ApprovalApi from 'api/approval/approval.api'
import HeaderCard from 'component/CardCustom/HeaderCard'
import Loading from 'component/Loading'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import MainButton from 'new-components/buttons/main-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { routeName } from 'routes/routes-name'
import { getBranch } from 'utils/app.utils'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}

const Approval = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const [load, setLoad] = useState<boolean>(false)

  const [dataApproval, setDataApproval] = useState<any>([])

  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('approvalId')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')

  const loadApproval = async () => {
    setLoad(true)
    const condition = {
      page: page,
      pageLimit: pageLimit,
      search: search,
      sortBy: sortBy,
      sortType: sortType,
      status: status === 'ALL' ? '' : status
    }

    await ApprovalApi.findApprovalAll(condition).then((res) => {
      setRowCount(res?.headers['x-total'] || 0)
      setDataApproval(res?.data)
    }).finally(() => {
      setLoad(false)
    })
  }

  useEffect(() => {
    loadApproval()
  }, [page, pageLimit, sortBy, sortType])

  const onCreate = () => {
    history.push(routeName.approval + '/create')
  }

  const onEdit = (obj: any) => {
    history.push(routeName.approval + '/update', obj)
  }

  const onActive = async () => {
    if (id) {
      ApprovalApi.updateStatusApproval(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          notiSuccess(t('OPERATIVE.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadApproval()
        } else {
          setIsOpenAlertModal(false)
          notiError(t('APPROVAL.MESSAGE.ERROR.ERROR'))
        }
      })
    }
  }

  const onDelete = async () => {
    if (id) {
      ApprovalApi.deteleApproval(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          notiSuccess(t('APPROVAL.MESSAGE.SUC_DELETE'))
          loadApproval()
        } else {
          setIsOpenAlertModal(false)
          notiError(t('APPROVAL.MESSAGE.ERROR.ERROR'))
        }
      })
    }
  }


  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => setPage(val)

  const handleChangeRowsPerPage = (limit: number) => setPageLimit(limit)

  const headCells = [
    { id: 'no', disablePadding: false, label: t('TABLE.NO'), width: '50px', align: 'center', },
    { id: 'approvalName', disablePadding: false, label: t('APPROVAL.TABLE.APPROVAL_NAME'), align: 'left', width: '220px' },
    { id: 'branchCreate', disablePadding: false, label: t('APPROVAL.TABLE.BRANCH_CREATE'), align: 'left', width: '220px' },
    { id: 'branchUse', disablePadding: false, label: t('APPROVAL.TABLE.BRANCH_USE'), align: 'left' },
    { id: 'nameUse', disablePadding: false, label: t('APPROVAL.TABLE.NAME_USE'), align: 'left', },
    { id: 'status', disablePadding: false, label: t('APPROVAL.TABLE.STATUS'), width: '80px' },
    { id: 'updatedBy', disablePadding: false, label: t('APPROVAL.TABLE.UPDATED_BY'), width: '100px' },
    { id: 'action', disablePadding: false, label: 'Action', width: '80px' }
  ]

  const renderData = (objData: any, index: number) => {
    index = page * pageLimit - pageLimit + index + 1
    const { approvalId, approvalName, mainBranchName, branchId, isMain, branches, approvalUsers, updatedBy, updatedAt, createdAt, status } = objData
    const statusBtnActive = objData.status === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = objData.status === 'INACTIVE' ? true : permissions.isUpdate.disabled

    const objRenderData = {
      key: approvalId,
      id: approvalId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: index },
        { option: 'TEXT', align: 'left', label: approvalName || '' },
        { option: 'TEXT', align: 'left', label: mainBranchName || '' },
        { option: 'TEXT', align: 'left', label: branches?.map((item: any) => item?.branchName).join(", ") || "-" },
        { option: 'TEXT', align: 'left', label: approvalUsers?.map((item: any) => item?.userFullName).join(", ") || "-" },
        { option: 'STATUS', align: 'center', label: status },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy || '-', updatedAt: updatedAt ?? '10/12/2564 08.59' } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            disabledIsEdit(isMain === '1', branchId) && { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            disabledIsEdit(isMain === '1', branchId) && { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            disabledIsEdit(isMain === '1', branchId) && { option: 'DIVIDER', label: '', disabled: false },
            disabledIsEdit(isMain === '1', branchId) ? { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled } : { option: 'VIEW', label: t(`APPROVELLIST.TABLE.VIEW`) },
            disabledIsEdit(isMain === '1', branchId) && { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        },
      ]
    }

    return (
      <TableRowCommon
        {...objRenderData}
        onedit={() => onEdit(objData)}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objData)}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objData)}
        onView={() => onEdit(objData)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objData)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.approvalName)
  }

  const disabledIsEdit = (isMain: boolean, branchId: number) => {
    if (isMain) {
      if (branchId === getBranch()) {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  }


  return (
    <Box>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`APPROVAL.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`APPROVAL.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { approvalName: name, status: t(`APPROVAL.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <Loading show={load} />
      <HeaderCard text={t('APPROVAL.TITLE')} />
      <Box paddingX="24px" paddingTop="16px">
        <Grid container spacing="16px">
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <TextInput
              onChange={(e) => setSearch(e.target.value)}
              label='ค้นหา ชื่อรายการ'
              fullWidth
              value={search}
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }} />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(e) => setStatus(e.target.value)}
              label={t('STATUS.LABEL')}
              options={[
                { value: 'ALL', name: t('APPROVAL.ALL') },
                { value: 'ACTIVE', name: t('APPROVAL.ACTIVE') },
                { value: 'INACTIVE', name: t('APPROVAL.INACTIVE') }
              ]}
              defaultValue='ALL'
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} xl={8}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <MainButton
                title={t('APPROVAL.SEARCH')}
                type='primary'
                variant='contained'
                style={{ width: '120px' }}
                onClick={() => {
                  setPage(1)
                  loadApproval()
                }} />
              <MainButton title={t('APPROVAL.BUTTON.CREATE')} disabled={permissions.isCreate.disabled} type='primary' variant='contained' onClick={() => onCreate()} startIcon={<AddCircleIcon />} />
            </Box>
          </Grid>
        </Grid>

        <Box paddingTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={dataApproval?.length ? dataApproval?.map((item: any, index: number) => {
              return renderData(item, index)
            }) : []}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default Approval

function getBranchId() {
  throw new Error('Function not implemented.')
}
